// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pricing New Page Styles */

.pricing-new-page {
    background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);
    min-height: 100vh;
    padding-top: 100px;
}

.pn-packages,
.pn-photo-pricing,
.footer-section-new {
    letter-spacing: 0.6px;
    font-family: var(--font-poppins), sans-serif;
}

/* Section Styles */
.pn-section {
    padding: 60px 0 15px 0;
}

.pn-section-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 0 200px;
    margin-bottom: 42px;
    position: relative;
}

.pn-section-header::before,
.pn-section-header::after {
    content: '';
    flex: 1 1;
    height: 2px;
    background: linear-gradient(90deg, rgba(70, 25, 163, 0.3) 0%, rgba(237, 113, 151, 0.3) 100%);
}

.pn-section-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #4619A3 0%, #ED7197 100%);
    color: white;
    border-radius: 999px;
    font-weight: 700;
    letter-spacing: 0.04em;
    white-space: nowrap;
    padding: 8px 30px;
    font-size: 18px;
}

/* Hero Section */
.pn-hero {
    text-align: center;
    padding: 40px 0;
}

.pn-logo {
    max-width: 200px;
    height: auto;
}

/* Packages Section */
.pn-packages {
    background-color: transparent;
}

.pn-plans-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(240px, 1fr));
    gap: 28px;
    /* max-width: 1280px; */
    margin: 0 auto;
}

.pn-plan-card {
    background: white;
    border: 2px solid var(--border-color, #d6d3e1);
    border-radius: 16px;
    padding: 15px 10px 17px;
    position: relative;
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    transform: translateZ(0) scale(1);
    transform-origin: center center;
    will-change: transform, box-shadow, border-color;
    text-align: left;
    min-height: 520px;
    overflow: hidden;
}


.pn-addons-label2 {
    background: linear-gradient(90deg, #4619A3 0%, #ED7197 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-weight: 700;
}

.pn-btn-contact {
    background: #fff;
    border: 2px solid transparent;
    border-radius: 10px;
    position: relative;
    background-image: linear-gradient(#fff, #fff), linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    width: 100%;
    padding: 10px 19px;
    font-size: 30px;
    font-weight: 600;
    margin: 5px 2px;
}

.pn-btn-contact .btn-text {
    background: linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    display: inline-block;
}

/* Add-Ons Included Gradient Text */
.pn-addons-label2 {
    background: linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 15px;
    font-weight: 700;
}

.pn-plan-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 8px;
    background: var(--top-border-color, #8b5cf6);
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;
}

.pn-plan-card:hover {
    transform: scale(1.05);
    border-color: rgba(139, 92, 246, 0.35);
    box-shadow: 0 18px 40px rgba(99, 24, 198, 0.12);
}

.pn-badge {
    position: absolute;
    top: 15px;
    right: 0px;
    font-size: 16px;
    font-weight: 500;
    padding: 2px 8px;
    border-radius: 0;
    text-transform: capitalize;
}

.pn-badge-popular {
    background: linear-gradient(90deg, #4619A3 0%, #ED7197 100%);
    color: white;
}

.pn-badge-best {
    background: linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);
    color: #ffffff;
}

.pn-plan-name {
    font-size: 25px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 24px;
    margin-top: 10px;
    padding: 0 10px;
}

/* Pricing Section */
.pn-pricing-section {
    margin: 0;
    padding: 0;
}

.pn-pricing-box {
    border: 1px solid var(--inner-border-color, #e5e7eb);
    border-radius: 22px;
    padding: 28px 35px;
    background: #ffffff;
    margin-bottom: 22px;
}

.pn-price-divider {
    height: 1.5px;
    width: 100%;
    margin: 12px 0;
    background: var(--accent-color, #e5e7eb);
}

.pn-price-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-bottom: 2px;
    text-align: center;
}

.pn-price {
    font-size: 25px;
    font-weight: 800;
    color: var(--accent-color, #111827);
    line-height: 1.02;
}

.pn-credits {
    font-size: 16px;
    color: #4b5563;
    text-transform: capitalize;
}

@media (min-width: 1400px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 1400px;
    }
}


.pn-discount-badge {
    background: linear-gradient(135deg, var(--discount-color));
    color: white;
    padding: 5px 14px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 500;
    display: inline-flex;
    margin-top: 8px;
}

.pn-contact-button {
    padding: 32px 0 0;
}


.pn-btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

/* Features Section */
.pn-features {
    text-align: left;
    margin-top: 20px;
    padding: 0px 10px;
}

.pn-addons-label {
    font-size: 15px;
    font-weight: 700;
    color: var(--accent-color, #4b5563);
    text-transform: capitalize;
    margin-bottom: 18px;
}


.pn-features ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.pn-features li {
    font-size: 14px;
    color: #363636;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 600;
}

.pn-features li .pn-check-icon {
    width: 26px;
    height: 26px;
    display: grid;
    place-items: center;
}

.pn-features li .pn-check-icon svg {
    width: 24px;
    height: 24px;
}

/* Photo Creation Pricing Section */
.pn-photo-pricing {
    background: transparent;
    padding: 60px 0 60px 0;
}

.pn-table-responsive {
    overflow-x: auto;
    /* border-radius: 20px; */
    box-shadow: 0 15px 40px rgba(15, 23, 42, 0.08);
}

.pn-pricing-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    min-width: 760px;
}

.pn-pricing-table thead th {
    color: white;
    padding: 15px 18px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

tbody,
td,
tfoot,
th,
thead,
tr {
    border-color: #ccc9c9;
    border-style: solid;
    border-width: 0;
}

.pn-pricing-table thead th:first-child {
    color: #111827;
    text-align: center;
    padding: 15px 8px;
    font-size: 16px;
    font-weight: 700;
    background: #eef2ff;
}

.pn-pricing-table thead th:nth-child(2) {
    background: #8b5cf6;
}

.pn-pricing-table thead th:nth-child(3) {
    background: #ec4899;
}

.pn-pricing-table thead th:nth-child(4) {
    background: #f59e0b;
}

.pn-pricing-table tbody tr {
    border-bottom: 1px solid #e5e7eb;
}

.pn-pricing-table tbody tr:last-child {
    border-bottom: none;
}

.pn-pricing-table tbody tr:hover {
    background-color: #faf9ff;
}

.pn-pricing-table td {
    padding: 15px 8px;
    text-align: center;
    font-size: 16px;
    color: #111827;
    font-weight: 600;
}

.pn-content-type {
    text-align: left;
    font-weight: 700;
    color: #111827;
}

/* Responsive Design */
@media (max-width: 1024px) {
    .pn-section {
        padding: 25px 0 15px 0 !important;
    }

    .pn-section-badge {
        width: 100%;
        justify-content: center;
        padding: 12px 30px !important;
        font-size: 15px !important;
    }

    .pn-plans-grid {
        grid-template-columns: repeat(2, minmax(240px, 1fr));
        gap: 24px;
    }
}

@media (max-width: 767px) {
    .pricing-new-page {
        padding-top: 70px !important;
    }

    .pn-section {
        padding: 25px 0 15px 0 !important;
    }

    .pn-price-divider {
        height: 0.5px;
    }

    .pn-price {
        font-size: 23px !important;
    }

    .pn-credits {
        font-size: 14px !important;
    }

    .pn-features li .pn-check-icon svg {
        width: 18px;
        height: 18px;
    }

    .pn-addons-label {
        font-size: 16px !important;
        margin-bottom: 8px !important;
    }

    .pn-features li {
        gap: 5px !important;
    }

    .pn-features li {
        font-size: 13px !important;
        margin-bottom: 5px !important;

    }

    .pn-pricing-table thead th:first-child {
        font-size: 12px !important;
    }

    .pn-plan-name {
        font-size: 18px !important;
    }

    .pn-plans-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .pn-section-header {
        margin-bottom: 20px;
        padding: 0 20px;
    }

    .pn-pricing-table {
        min-width: 100%;
    }

    .pn-pricing-table th,
    .pn-pricing-table td {
        padding: 14px 12px;
        font-size: 13px;
    }

    .pn-plan-name {
        font-size: 20px;
    }

    .pn-price {
        font-size: 26px;
    }
}

@media (max-width: 480px) {
    .pn-plan-card {
        padding: 24px 18px 20px;
        min-height: auto;
    }

    .pn-pricing-table th,
    .pn-pricing-table td {
        padding: 12px 10px;
        font-size: 12px;
    }

    .pn-section-header::before,
    .pn-section-header::after {
        display: none;
    }

    .pn-section-badge {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .pn-plan-card {
        padding: 20px 15px;
    }

    .pn-plans-grid {
        gap: 15px;
    }

    .pn-price {
        font-size: 18px;
    }

    .pn-plan-name {
        font-size: 16px;
    }

    .pn-pricing-table {
        font-size: 11px;
    }

    .pn-pricing-table thead th {
        padding: 12px 8px;
        font-size: 11px;
    }

    .pn-table-responsive {
        margin: 0 -15px;
    }
}

@media (min-width: 768px) and (max-width: 992px) {
    .pn-plan-name {
        font-size: 22px !important;
    }
}

@media (min-width: 1025px) and (max-width: 1400px) {
    .pn-plan-name {
        font-size: 17px !important;
    }

    .pn-price {
        font-size: 18px !important;
    }

    /* .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
        max-width: 1300px;
    } */

    .pn-btn-contact {
        padding: 7px 19px !important;
        font-size: 20px !important;
    }

    .pn-badge {
        font-size: 12px !important;
    }

    .pn-credits {
        font-size: 13px !important;
    }

    .pn-discount-badge {
        font-size: 10px !important;
    }

    .pn-addons-label {
        font-size: 13px !important;
        margin-bottom: 12px !important;
    }

    .pn-features li {
        font-size: 11px !important;
        gap: 7px !important;
    }

    .pn-features li .pn-check-icon svg {
        width: 18px !important;
        height: 18px !important;
    }

    .pn-section-badge {
        font-size: 14px !important;
    }

    .pn-pricing-table thead th,
    .pn-pricing-table td,
    .pn-pricing-table thead th:first-child {
        font-size: 14px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/PricingNew/PricingNew.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,SAAO;IACP,WAAW;IACX,4FAA4F;AAChG;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,4DAA4D;IAC5D,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,8CAA8C;IAC9C,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,6EAA6E;IAC7E,iCAAiC;IACjC,+BAA+B;IAC/B,gDAAgD;IAChD,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,4DAA4D;IAC5D,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,kGAAkG;IAClG,6BAA6B;IAC7B,wCAAwC;IACxC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+DAA+D;IAC/D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;;IAErB,qBAAqB;AACzB;;AAEA,mCAAmC;AACnC;IACI,+DAA+D;IAC/D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,4CAA4C;IAC5C,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,4DAA4D;IAC5D,YAAY;AAChB;;AAEA;IACI,+DAA+D;IAC/D,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oDAAoD;IACpD,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;;IAEI;;;;;;QAMI,iBAAiB;IACrB;AACJ;;;AAGA;IACI,0DAA0D;IAC1D,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,0BAA0B;IAC1B,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,mCAAmC;AACnC;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;QACI,iCAAiC;IACrC;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,6BAA6B;QAC7B,0BAA0B;IAC9B;;IAEA;QACI,oDAAoD;QACpD,SAAS;IACb;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;;IAEjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;;;;OAMG;;IAEH;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;QAGI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Pricing New Page Styles */\r\n\r\n.pricing-new-page {\r\n    background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);\r\n    min-height: 100vh;\r\n    padding-top: 100px;\r\n}\r\n\r\n.pn-packages,\r\n.pn-photo-pricing,\r\n.footer-section-new {\r\n    letter-spacing: 0.6px;\r\n    font-family: var(--font-poppins), sans-serif;\r\n}\r\n\r\n/* Section Styles */\r\n.pn-section {\r\n    padding: 60px 0 15px 0;\r\n}\r\n\r\n.pn-section-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0;\r\n    padding: 0 200px;\r\n    margin-bottom: 42px;\r\n    position: relative;\r\n}\r\n\r\n.pn-section-header::before,\r\n.pn-section-header::after {\r\n    content: '';\r\n    flex: 1;\r\n    height: 2px;\r\n    background: linear-gradient(90deg, rgba(70, 25, 163, 0.3) 0%, rgba(237, 113, 151, 0.3) 100%);\r\n}\r\n\r\n.pn-section-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: linear-gradient(90deg, #4619A3 0%, #ED7197 100%);\r\n    color: white;\r\n    border-radius: 999px;\r\n    font-weight: 700;\r\n    letter-spacing: 0.04em;\r\n    white-space: nowrap;\r\n    padding: 8px 30px;\r\n    font-size: 18px;\r\n}\r\n\r\n/* Hero Section */\r\n.pn-hero {\r\n    text-align: center;\r\n    padding: 40px 0;\r\n}\r\n\r\n.pn-logo {\r\n    max-width: 200px;\r\n    height: auto;\r\n}\r\n\r\n/* Packages Section */\r\n.pn-packages {\r\n    background-color: transparent;\r\n}\r\n\r\n.pn-plans-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(240px, 1fr));\r\n    gap: 28px;\r\n    /* max-width: 1280px; */\r\n    margin: 0 auto;\r\n}\r\n\r\n.pn-plan-card {\r\n    background: white;\r\n    border: 2px solid var(--border-color, #d6d3e1);\r\n    border-radius: 16px;\r\n    padding: 15px 10px 17px;\r\n    position: relative;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\r\n    transform: translateZ(0) scale(1);\r\n    transform-origin: center center;\r\n    will-change: transform, box-shadow, border-color;\r\n    text-align: left;\r\n    min-height: 520px;\r\n    overflow: hidden;\r\n}\r\n\r\n\r\n.pn-addons-label2 {\r\n    background: linear-gradient(90deg, #4619A3 0%, #ED7197 100%);\r\n    -webkit-background-clip: text;\r\n    background-clip: text;\r\n    color: transparent;\r\n    font-weight: 700;\r\n}\r\n\r\n.pn-btn-contact {\r\n    background: #fff;\r\n    border: 2px solid transparent;\r\n    border-radius: 10px;\r\n    position: relative;\r\n    background-image: linear-gradient(#fff, #fff), linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);\r\n    background-origin: border-box;\r\n    background-clip: padding-box, border-box;\r\n    width: 100%;\r\n    padding: 10px 19px;\r\n    font-size: 30px;\r\n    font-weight: 600;\r\n    margin: 5px 2px;\r\n}\r\n\r\n.pn-btn-contact .btn-text {\r\n    background: linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    background-clip: text;\r\n\r\n    display: inline-block;\r\n}\r\n\r\n/* Add-Ons Included Gradient Text */\r\n.pn-addons-label2 {\r\n    background: linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    background-clip: text;\r\n    margin-bottom: 15px;\r\n    font-weight: 700;\r\n}\r\n\r\n.pn-plan-card::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 8px;\r\n    background: var(--top-border-color, #8b5cf6);\r\n    border-top-left-radius: 28px;\r\n    border-top-right-radius: 28px;\r\n}\r\n\r\n.pn-plan-card:hover {\r\n    transform: scale(1.05);\r\n    border-color: rgba(139, 92, 246, 0.35);\r\n    box-shadow: 0 18px 40px rgba(99, 24, 198, 0.12);\r\n}\r\n\r\n.pn-badge {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 0px;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    padding: 2px 8px;\r\n    border-radius: 0;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.pn-badge-popular {\r\n    background: linear-gradient(90deg, #4619A3 0%, #ED7197 100%);\r\n    color: white;\r\n}\r\n\r\n.pn-badge-best {\r\n    background: linear-gradient(to right, #6A3CC7 0%, #E0C34A 100%);\r\n    color: #ffffff;\r\n}\r\n\r\n.pn-plan-name {\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n    color: #111827;\r\n    margin-bottom: 24px;\r\n    margin-top: 10px;\r\n    padding: 0 10px;\r\n}\r\n\r\n/* Pricing Section */\r\n.pn-pricing-section {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.pn-pricing-box {\r\n    border: 1px solid var(--inner-border-color, #e5e7eb);\r\n    border-radius: 22px;\r\n    padding: 28px 35px;\r\n    background: #ffffff;\r\n    margin-bottom: 22px;\r\n}\r\n\r\n.pn-price-divider {\r\n    height: 1.5px;\r\n    width: 100%;\r\n    margin: 12px 0;\r\n    background: var(--accent-color, #e5e7eb);\r\n}\r\n\r\n.pn-price-row {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-bottom: 2px;\r\n    text-align: center;\r\n}\r\n\r\n.pn-price {\r\n    font-size: 25px;\r\n    font-weight: 800;\r\n    color: var(--accent-color, #111827);\r\n    line-height: 1.02;\r\n}\r\n\r\n.pn-credits {\r\n    font-size: 16px;\r\n    color: #4b5563;\r\n    text-transform: capitalize;\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n\r\n    .container,\r\n    .container-lg,\r\n    .container-md,\r\n    .container-sm,\r\n    .container-xl,\r\n    .container-xxl {\r\n        max-width: 1400px;\r\n    }\r\n}\r\n\r\n\r\n.pn-discount-badge {\r\n    background: linear-gradient(135deg, var(--discount-color));\r\n    color: white;\r\n    padding: 5px 14px;\r\n    border-radius: 999px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    display: inline-flex;\r\n    margin-top: 8px;\r\n}\r\n\r\n.pn-contact-button {\r\n    padding: 32px 0 0;\r\n}\r\n\r\n\r\n.pn-btn-primary:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);\r\n}\r\n\r\n/* Features Section */\r\n.pn-features {\r\n    text-align: left;\r\n    margin-top: 20px;\r\n    padding: 0px 10px;\r\n}\r\n\r\n.pn-addons-label {\r\n    font-size: 15px;\r\n    font-weight: 700;\r\n    color: var(--accent-color, #4b5563);\r\n    text-transform: capitalize;\r\n    margin-bottom: 18px;\r\n}\r\n\r\n\r\n.pn-features ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.pn-features li {\r\n    font-size: 14px;\r\n    color: #363636;\r\n    margin-bottom: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    font-weight: 600;\r\n}\r\n\r\n.pn-features li .pn-check-icon {\r\n    width: 26px;\r\n    height: 26px;\r\n    display: grid;\r\n    place-items: center;\r\n}\r\n\r\n.pn-features li .pn-check-icon svg {\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n/* Photo Creation Pricing Section */\r\n.pn-photo-pricing {\r\n    background: transparent;\r\n    padding: 60px 0 60px 0;\r\n}\r\n\r\n.pn-table-responsive {\r\n    overflow-x: auto;\r\n    /* border-radius: 20px; */\r\n    box-shadow: 0 15px 40px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.pn-pricing-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    background: white;\r\n    min-width: 760px;\r\n}\r\n\r\n.pn-pricing-table thead th {\r\n    color: white;\r\n    padding: 15px 18px;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\ntbody,\r\ntd,\r\ntfoot,\r\nth,\r\nthead,\r\ntr {\r\n    border-color: #ccc9c9;\r\n    border-style: solid;\r\n    border-width: 0;\r\n}\r\n\r\n.pn-pricing-table thead th:first-child {\r\n    color: #111827;\r\n    text-align: center;\r\n    padding: 15px 8px;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    background: #eef2ff;\r\n}\r\n\r\n.pn-pricing-table thead th:nth-child(2) {\r\n    background: #8b5cf6;\r\n}\r\n\r\n.pn-pricing-table thead th:nth-child(3) {\r\n    background: #ec4899;\r\n}\r\n\r\n.pn-pricing-table thead th:nth-child(4) {\r\n    background: #f59e0b;\r\n}\r\n\r\n.pn-pricing-table tbody tr {\r\n    border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.pn-pricing-table tbody tr:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.pn-pricing-table tbody tr:hover {\r\n    background-color: #faf9ff;\r\n}\r\n\r\n.pn-pricing-table td {\r\n    padding: 15px 8px;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    color: #111827;\r\n    font-weight: 600;\r\n}\r\n\r\n.pn-content-type {\r\n    text-align: left;\r\n    font-weight: 700;\r\n    color: #111827;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1024px) {\r\n    .pn-section {\r\n        padding: 25px 0 15px 0 !important;\r\n    }\r\n\r\n    .pn-section-badge {\r\n        width: 100%;\r\n        justify-content: center;\r\n        padding: 12px 30px !important;\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    .pn-plans-grid {\r\n        grid-template-columns: repeat(2, minmax(240px, 1fr));\r\n        gap: 24px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .pricing-new-page {\r\n        padding-top: 70px !important;\r\n    }\r\n\r\n    .pn-section {\r\n        padding: 25px 0 15px 0 !important;\r\n    }\r\n\r\n    .pn-price-divider {\r\n        height: 0.5px;\r\n    }\r\n\r\n    .pn-price {\r\n        font-size: 23px !important;\r\n    }\r\n\r\n    .pn-credits {\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    .pn-features li .pn-check-icon svg {\r\n        width: 18px;\r\n        height: 18px;\r\n    }\r\n\r\n    .pn-addons-label {\r\n        font-size: 16px !important;\r\n        margin-bottom: 8px !important;\r\n    }\r\n\r\n    .pn-features li {\r\n        gap: 5px !important;\r\n    }\r\n\r\n    .pn-features li {\r\n        font-size: 13px !important;\r\n        margin-bottom: 5px !important;\r\n\r\n    }\r\n\r\n    .pn-pricing-table thead th:first-child {\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .pn-plan-name {\r\n        font-size: 18px !important;\r\n    }\r\n\r\n    .pn-plans-grid {\r\n        grid-template-columns: 1fr;\r\n        gap: 20px;\r\n    }\r\n\r\n    .pn-section-header {\r\n        margin-bottom: 20px;\r\n        padding: 0 20px;\r\n    }\r\n\r\n    .pn-pricing-table {\r\n        min-width: 100%;\r\n    }\r\n\r\n    .pn-pricing-table th,\r\n    .pn-pricing-table td {\r\n        padding: 14px 12px;\r\n        font-size: 13px;\r\n    }\r\n\r\n    .pn-plan-name {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .pn-price {\r\n        font-size: 26px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .pn-plan-card {\r\n        padding: 24px 18px 20px;\r\n        min-height: auto;\r\n    }\r\n\r\n    .pn-pricing-table th,\r\n    .pn-pricing-table td {\r\n        padding: 12px 10px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .pn-section-header::before,\r\n    .pn-section-header::after {\r\n        display: none;\r\n    }\r\n\r\n    .pn-section-badge {\r\n        width: 100%;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .pn-plan-card {\r\n        padding: 20px 15px;\r\n    }\r\n\r\n    .pn-plans-grid {\r\n        gap: 15px;\r\n    }\r\n\r\n    .pn-price {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .pn-plan-name {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .pn-pricing-table {\r\n        font-size: 11px;\r\n    }\r\n\r\n    .pn-pricing-table thead th {\r\n        padding: 12px 8px;\r\n        font-size: 11px;\r\n    }\r\n\r\n    .pn-table-responsive {\r\n        margin: 0 -15px;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 992px) {\r\n    .pn-plan-name {\r\n        font-size: 22px !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1400px) {\r\n    .pn-plan-name {\r\n        font-size: 17px !important;\r\n    }\r\n\r\n    .pn-price {\r\n        font-size: 18px !important;\r\n    }\r\n\r\n    /* .container,\r\n    .container-lg,\r\n    .container-md,\r\n    .container-sm,\r\n    .container-xl {\r\n        max-width: 1300px;\r\n    } */\r\n\r\n    .pn-btn-contact {\r\n        padding: 7px 19px !important;\r\n        font-size: 20px !important;\r\n    }\r\n\r\n    .pn-badge {\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .pn-credits {\r\n        font-size: 13px !important;\r\n    }\r\n\r\n    .pn-discount-badge {\r\n        font-size: 10px !important;\r\n    }\r\n\r\n    .pn-addons-label {\r\n        font-size: 13px !important;\r\n        margin-bottom: 12px !important;\r\n    }\r\n\r\n    .pn-features li {\r\n        font-size: 11px !important;\r\n        gap: 7px !important;\r\n    }\r\n\r\n    .pn-features li .pn-check-icon svg {\r\n        width: 18px !important;\r\n        height: 18px !important;\r\n    }\r\n\r\n    .pn-section-badge {\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    .pn-pricing-table thead th,\r\n    .pn-pricing-table td,\r\n    .pn-pricing-table thead th:first-child {\r\n        font-size: 14px !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
